import moment from "moment";
import validationRules from "../validationRules";
import { formatDateString } from "@/components/forms/components/utils";
validationRules.register("isbefore", function (record, fieldMetadataMap, fieldName, t) {
    var args = [];
    for (var _i = 4; _i < arguments.length; _i++) {
        args[_i - 4] = arguments[_i];
    }
    var compareto = args[0] || undefined;
    //const dateTimeFormat = args[1] || undefined;
    // On décode le format : "_" -> ":"
    var dateTimeFormat = args[1] ? args[1].replace(/_/g, ":") : undefined;
    var valueBefore = record[fieldName] || "";
    var valueAfter = record[compareto] || "";
    // Garde : rien à valider si les données nécessaires sont manquantes
    if (!compareto || !dateTimeFormat || !valueBefore || !valueAfter) {
        return true;
    }
    var newFormatString = formatDateString(dateTimeFormat);
    var ddFormat = dateTimeFormat.split("", 1);
    var timer = dateTimeFormat.split(" ", 2);
    //const reFormat = "DD/MM/YYYY " + timer[1];
    var reFormat = "DD/MM/YYYY " + (timer[1] || "HH:mm");
    if (fieldMetadataMap.get(fieldName).type === "datetimecombo" ||
        fieldMetadataMap.get(fieldName).type === "datetime") {
        var vbefore = new Date(valueBefore).getTime();
        var vafter = new Date(valueAfter).getTime();
        if (!isNaN(vbefore)) {
            if (vbefore < vafter) {
                return true;
            }
            else {
                return "".concat(fieldName, " should be before ").concat(compareto, ".");
            }
        }
        else {
            if (ddFormat[0] === "d" || ddFormat[0] === "D") {
                var dateMomentObjectBefore = moment(valueBefore, reFormat);
                var dateMomentObjectAfter = moment(valueAfter, reFormat);
                var vBefore = dateMomentObjectBefore.toDate();
                var vAfter = dateMomentObjectAfter.toDate();
                if (vBefore < vAfter) {
                    return true;
                }
                else {
                    return "".concat(fieldName, " should be before ").concat(compareto, ".");
                }
            }
            else {
                var vBefore = moment(valueBefore, newFormatString).toDate();
                var vAfter = moment(valueAfter, newFormatString).toDate();
                if (vBefore < vAfter) {
                    return true;
                }
                else {
                    return "".concat(fieldName, " should be before ").concat(compareto, ".");
                }
            }
            /*if (vbefore.diff(vafter, "seconds") < 0) {
              return true;
            } else {
              return `${fieldName} should be before ${compareto}.`;
            }*/
        }
    }
    else if (fieldMetadataMap.get(fieldName).type === "date") {
        var dateFormat = "DD/MM/YYYY";
        var dateMomentObjectBefore = moment(valueBefore, dateFormat, true);
        var dateMomentObjectAfter = moment(valueAfter, dateFormat, true);
        if (!dateMomentObjectBefore.isValid() ||
            !dateMomentObjectAfter.isValid()) {
            return "".concat(fieldName, " ou ").concat(compareto, " a un format de date invalide.");
        }
        if (dateMomentObjectBefore.isBefore(dateMomentObjectAfter)) {
            return true;
        }
        else {
            return "".concat(fieldName, " doit \u00EAtre avant ").concat(compareto, ".");
        }
    }
    return true;
});
